/** Preserve category query normalization without shadowing the slug transport. */
export const API_CONFIG = {
  timeoutMs: 0,
  productVariantImages: undefined as boolean | undefined,
  stableCategoryDetails: true,
};
